<template>
    <div>
        <div class="title_box">
            <div class="report_subtitle" ref="fishqc_stander">{{$t('rankindex.report_standard')}}</div>
            <div class="title_line"></div>
        </div>
        <div>
            <div v-for="item in rank_fish_desc" :class="['fishblock',item.class]">
                <div class="display_flex flex-wrap_wrap">
                    <div>
                        <img :src="item.fish">
                    </div>
                    <div class="padding_left_16">
                        <div :class="['title',item.textcolor]">{{item.title}}</div>
                        <div class="desc">{{item.desc}}</div>
                    </div>
                </div>
            </div>
            <div class="desc4">{{$t('rankindex.test_methor_desc1')}}</div>
        </div>
        <div class="title_box">
            <div class="report_subtitle" ref="fishqc_introduction">{{$t('rankindex.fishqcintroduction')}}</div>
            <div class="title_line"></div>
        </div>
        <!-- <div class="testresult">方法</div>
        <div class="result1">符合传统的化学测试技术Testing 1.0和基本法规，只是商品进入市场最基本要求。小鱼亲测要做的，是通过领先的生物测试技术Testing 2.0，通过同类商品的横向比较，为消费者选出更安全和优质的产品。根据结果，小鱼亲测将商品分为绿鱼、黄鱼、红鱼。 <br>作为第三方消费品信息平台，小鱼亲测的标准是由来自经验丰富的科研团队，毒理学专家与来自12个国家的科学顾问团参考中国、欧盟、美国、日本、世卫组织及OECD等安全标准，结合领先的生物测试技术Testing 2.0（鱼胚胎毒理检测技术）制定，检测结果是更高标准的安全指引。</div>
        <div>
            <div class="textalign_center padding_top_38">
                <div class="inline-block  vertical-top">
                    <img src="http://p1.fishqc.net/FnivJEmUSpxpOv-Gmvij4tOCgw0a" class="vertical-middle" style="padding-bottom:22px;box-sizeing:border-box;">
                    <div>
                        <ul class="vs-right-ul">
                            <li>
                                <span class="vs-right-li grave">化学测试</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="testresult_vs">VS</div>
                <div class="inline-block vertical-top">
                    <img src="http://p1.fishqc.net/FnivJEmUSpxpOv-Gmvij4tOCgw0a" class="vertical-middle" style="padding-bottom:22px;box-sizeing:border-box;">
                    <ul class="vs-right-ul" style="text-align:left">
                        <li>
                            <span class="vs-right-li">鲭鳉鱼胚胎慢性毒物测试</span>
                        </li>
                        <li>
                            <span class="vs-right-li">斑马鱼胚胎急性毒物测试</span>
                        </li>
                        <li>
                            <span class="vs-right-li">禁用成分筛查</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div> -->
        <div class="testresult">{{$t('rankindex.test_methor_desc3')}}</div>
        <div class="secondtitle">{{$t('rankindex.test_methor_desc4')}}</div>
        <div class="result1">{{$t('rankindex.test_methor_desc5')}}</div>
        <div class="display_flex justify-content_flex-justify tiaochacontain">
            <div v-for="item in tiaocha" class="textalign_center ">
                <img :src="item.img" class="tiaochaimg">
                <div class="tiaochatxt">{{item.icondesc}}</div>
            </div>
        </div>
        <div class="secondtitle padding_top_24">{{$t('rankindex.test_methor_desc10')}}</div>
        <div class="result1">{{$t('rankindex.test_methor_desc11')}}</div>
        <div class="display_flex justify-content_flex-justify tiaochacontain">
            <div v-for="item in caigou" class="textalign_center ">
                <img :src="item.img" class="tiaochaimg">
                <div class="tiaochatxt">{{item.icondesc}}</div>
            </div>
        </div>
        <div class="testresult">{{$t('rankindex.test_methor_desc2')}}</div>
        <div class="secondtitle">{{$t('rankindex.test_methor_desc16')}}</div>
        <div class="padding_left_16">
            <div class="desc5">{{$t('rankindex.test_methor_desc17')}}</div>
            <div class="display_flex flex-wrap_wrap align-items_center">
                <div class="position_relative">
                    <img src="http://p1.fishqc.net/FuXsRrIYDdh-HpQ0LTlfQ2xXGaCl" class="reportinfo_img1">
                    <div class="reportinfo_text">
                        {{$t('rankindex.test_methor_desc18')}}
                        <img src="http://p1.fishqc.net/Fg0__JrIZ7_iV7CaMTv6trUmFU3b" class="position_left">
                    </div>
                </div>
                <div>
                    <ul class="vs-right-ul_left">
                        <li>
                            <span class="vs-right-li">{{$t('rankindex.test_methor_desc19')}}</span>
                        </li>
                        <li>
                            <span class="vs-right-li">{{$t('rankindex.test_methor_desc20')}}</span>
                        </li>
                        <li>
                            <span class="vs-right-li">{{$t('rankindex.test_methor_desc21')}}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="secondtitle padding_top_24">{{$t('rankindex.test_methor_desc22')}}</div>
        <div class="padding_left_16">
            <div class="desc5">{{$t('rankindex.test_methor_desc23')}}</div>
            <div class="display_flex justify-content_flex-justify">
                <div class="reportinfo_img2" :style="{backgroundImage: 'url(' + 'http://p1.fishqc.net/FsFrZDasCaNXpFqKoLRLxW8082dm' + ')'}">{{$t('rankindex.test_methor_desc24')}}</div>
                <div class="reportinfo_img2" :style="{backgroundImage: 'url(' + 'http://p1.fishqc.net/FiE4uAZ38ybjWXYse6_RnE9xYDO7' + ')'}">{{$t('rankindex.test_methor_desc25')}}</div>
            </div>
            <div class="display_flex justify-content_flex-justify padding_top_24">
                <div class="reportinfo_img3" :style="{backgroundImage: 'url(' + 'http://p1.fishqc.net/FrFdjOvHEouRSZkS2lA3Oews37LQ' + ')'}">{{$t('rankindex.test_methor_desc26')}}</div>
                <div class="reportinfo_img3" :style="{backgroundImage: 'url(' + 'http://p1.fishqc.net/FvDb-GsXSFvKZ4hzDqMmiGmH3qBa' + ')'}">{{$t('rankindex.test_methor_desc27')}}</div>
                <div class="reportinfo_img3" :style="{backgroundImage: 'url(' + 'http://p1.fishqc.net/Fr5YdSu2sM6JI-HAXTU9n9d4_3DN' + ')'}">{{$t('rankindex.test_methor_desc28')}}</div>
            </div>
            <div class="desc6">{{$t('rankindex.test_methor_desc29')}}</div>
            <div class="desc7">{{$t('rankindex.test_methor_desc30')}}</div>
            <div class="display_flex align-items_center">
                <div>
                    <img src="http://p1.fishqc.net/FrDrC02BKC_I_OvmYFcICjnx_C5o">
                </div>
                <div class="desc8">{{$t('rankindex.test_methor_desc31')}}</div>
            </div>
            <div class="secondtitle padding_top_32">{{$t('rankindex.test_methor_desc32')}}</div>
            <div class="padding_left_16">
                <div class="desc5">{{$t('rankindex.test_methor_desc33')}}</div>
                <div class="padding-bottom-16">
                    <img src="http://p1.fishqc.net/FmkBq4PiH4tkFbthgimkEwBdUSn5" alt="">
                </div>
                <div class="desc9">{{$t('rankindex.test_methor_desc34')}}</div>
                <div class="padding-bottom-16">
                    <img src="http://p1.fishqc.net/FjwKari-yOIpNtKcQjovVVjJOpu1" alt="">
                </div>
                <div class="desc9">{{$t('rankindex.test_methor_desc35')}}</div>
                <div class="display_flex align-items_center">
                    <div>
                        <img src="http://p1.fishqc.net/Frn7fU5sdyx_-AuX38d6P07ykSnW">
                    </div>
                    <div class="desc8">{{$t('rankindex.test_methor_desc36')}}</div>
                </div>
            </div>
            <div class="testresult">{{$t('rankindex.test_methor_desc37')}}</div>
            <div class="desc9" v-html="$t('rankindex.chengfendesc1')">
                <!-- 水中银通过我们后台独有的成分筛查算法，与美国食药局，欧盟，日本，中国食药局，粮农组织和世卫组织(FAO&WHO)的食品法典（CODEX Alimentarius）的禁止或者高风险的成分进行比对，进一步增强产品安全。 产品不得含有被以下政府或相关管理部门禁止使用的材料；包括已证实会引起并发症、生态毒性或经科学安全评估证明造成污染的 化学物，有关政府、相关部门及条例如下：
                <div class="padding_bottom_30"> 美国：食品药品监督管理局〈在食品、药物、化妆品和医疗设备中使用的颜色添加剂概要〉和〈禁用和限制成分〉，以及〈食品添加剂状况列表（EAFUS）〉。</div>
                <div class="padding_bottom_30"> 欧盟：欧盟委员会第 1333/2008号，1223/2009号，1129/2011号及1130/2011号，以及欧盟化学品管理局高度关注物质（SVHC）列（2017）。 </div>
                <div class="padding_bottom_30">中国：国家食品药品监督管理总局〈化妆品安全和技术标准〉（2015）及〈食品安全标准：食品添加剂使用标准〉（GB2760-2014）。</div>
                <div class="padding_bottom_30"> 日本：〈化妆品标准〉（2000）及〈食品添加剂使用标准〉（2017）。</div>
                <div class="padding_bottom_30"> 粮农组织和世卫组织：〈食品法典〉。</div> -->
            </div>
            <div>
                <img src="http://p1.fishqc.net/FpMhY-eyVYC_f2_HQCum5FEuiGKO" alt="">
            </div>
            <div class="testresult">{{$t('rankindex.test_methor_desc38')}}</div>
            <div class="padding_left_16">
                <div class="display_flex justify-content_flex-justify height_80">
                    <div class="fishqc_tech_title  textalign_left" style="padding-left: 40px;box-sizing:border-box;">
                        <span  style="width: 164px;display:inline-block" v-html="$t('rankindex.test_methor_desc39')"></span>
                    </div>
                    <div class="fishqc_tech_title lie2 textalign_left" style="padding-left: 50px;box-sizing:border-box;">
                        <span  style="width: 168px;display:inline-block" v-html="$t('rankindex.test_methor_desc40')"></span>
                    </div>
                    <div class="fishqc_tech_title  lie3 textalign_center" style="padding-left: 62px;box-sizing:border-box;">
                        <span  style="width: 104px;display:inline-block">{{$t('rankindex.test_methor_desc41')}}</span>
                    </div>
                    <div class="fishqc_tech_title lie4 textalign_center" style="padding-left: 68px;box-sizing:border-box;">
                        <span  style="width: 90px;display:inline-block">{{$t('rankindex.test_methor_desc42')}}</span>
                    </div>
                </div>
                <div class="display_flex justify-content_flex-justify height_150">
                    <div class="fishqc_tech_title  textalign_justify" >
                        <span class="fishqc_table" style="width: 152px;">{{$t('rankindex.test_methor_desc43')}}</span>
                    </div>
                    <div class="fishqc_tech_title lie2  textalign_justify" style="padding-left: 64px;box-sizing:border-box;">
                        <span class="fishqc_table" style="width: 140px;">{{$t('rankindex.test_methor_desc44')}}</span>
                    </div>
                    <div class="fishqc_tech_title lie3  textalign_left" style="padding-left: 70px;box-sizing:border-box;">
                        <span class="fishqc_table" style="width: 143px;">{{$t('rankindex.test_methor_desc45')}}</span>
                    </div>
                    <div class="fishqc_tech_title lie4 textalign_center" style="padding-left: 58px;text-align: left;">
                        <div style="padding-top:25px;box-sizing:border-box;display:inline-block;text-align: center;">
                            <img src="http://p1.fishqc.net/FjFwYIpjv8nV8yrfUg8O1ByMm-EF" alt="" >
                            <div class="testresult_status">{{$t('common.green_Title')}}<br>Excellent</div>
                        </div>
                        
                    </div>
                </div>
                <div class="display_flex justify-content_flex-justify height_150_yellow">
                    <div class="fishqc_tech_title  textalign_justify">
                        <span class="fishqc_table" style="width: 155px;">{{$t('rankindex.test_methor_desc43')}}</span>
                    </div>
                    <div class="fishqc_tech_title lie2 textalign_left" style="padding-left: 60px;box-sizing:border-box;">
                        <span class="fishqc_table" style="width: 145px;">{{$t('rankindex.test_methor_desc46')}}</span>
                    </div>
                    <div class="fishqc_tech_title lie3 textalign_left" style="padding-left: 60px;box-sizing:border-box;">
                        <span class="fishqc_table" style="width: 150px;">{{$t('rankindex.test_methor_desc47')}}</span>
                    </div>
                    <div class="fishqc_tech_title lie4 textalign_center" style="padding-left: 54px;text-align: left;">
                        <div style="padding-top:25px;box-sizing:border-box;display:inline-block;text-align: center;">
                            <img src="http://p1.fishqc.net/FrHXahfpGmA0YvRxEZj63DalUi33" alt="" >
                            <div class="testresult_status yellow">{{$t('common.yellow_Title')}}<br>Basic </div>
                        </div>
                    </div>
                </div>
                <div class="display_flex justify-content_flex-justify height_150_red">
                    <div class="fishqc_tech_title  textalign_justify">
                        <span class="fishqc_table padding_top_15" style="width: 174px;">{{$t('rankindex.test_methor_desc48')}}</span>
                    </div>
                    <div class="fishqc_tech_title lie2 textalign_left" style="padding-left: 40px;box-sizing:border-box;">
                        <span class="fishqc_table padding_top_15" style="width: 156px;">{{$t('rankindex.test_methor_desc49')}}</span>
                    </div>
                    <div class="fishqc_tech_title lie3 textalign_left" style="padding-left: 50px;box-sizing:border-box;">
                        <span class="fishqc_table padding_top_15" style="width: 110px;">{{$t('rankindex.test_methor_desc50')}}</span>
                    </div>
                    <div class="fishqc_tech_title lie4 textalign_center">
                        <div style="padding-top:22px;box-sizing:border-box;display:inline-block">
                            <img src="http://p1.fishqc.net/FoWZ9FE5XEss6hwmTeDSSM7dFIOw" alt="" >
                            <div class="testresult_status red">{{$t('common.red_Title')}}<br>Sub-Optimal</div>
                        </div>
                        
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";

.margin_top_100 {
    margin-top: 100px;
}
.margin_top_32{
    margin-top: 32px;
    box-shadow:0;
}
.padding-32 {
    padding: 32px 0;
    box-sizing: border-box;
}

.padding-bottom-16 {
    padding: 0px 0 16px;
    box-sizing: border-box;
}

.content_bottom_L{
    display:inline-block;
    .date{
        padding-left:6px;
        box-sizing:border-box;
        color:#888888
    }
}
.content_bottom_R{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 12px;
    display:inline-block;
    padding:6px 16px;
    box-sizing:border-box;
    background: linear-gradient(270deg, #28D877 0%, #0DC6B8 100%);
    border-radius: 0px 12px 12px 12px;
    
}

.reportmenu {
    width: 384px;
    max-height: 500px;
    padding: 0 32px 34px;
    box-sizing: border-box;
    background: #FFFFFF;
    border: 1px solid #F4F4F5;
    text-align: left;
    
    &.boxshadow{
        box-shadow: 0 10px 30px 0 rgba(233, 233, 235, 0.3);
    }

    .title {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
        padding: 26px 0 16px;
        box-sizing: border-box;
        border-bottom: 1px solid #E5E5E5;
    }

    .title_list {
        margin-top: 16px;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 24px;
        position: relative;
        padding-left: 16px;
        cursor: pointer;

        &:hover {
            color: #60DEB4;
        }

        &:before {
            content: '';
            position: absolute;
            left: 0%;
            top: 50%;
            transform: translate(0, -50%);
            width: 8px;
            height: 8px;
            background: #60DEB4;
            border-radius: 56px;

        }

        .active {
            color: #60DEB4;
        }
    }

    .nextreport_title{
        padding-top: 16px;
        padding-bottom: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333342;
        line-height: 24px;
    }
}

.padding_16 {
    padding: 16px 0;
    box-sizing: border-box;
}

.reportcontian {
    width: 792px;
    text-align: left;

    .report_title {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 48px;
    }

    .report_collect {
        display: inline-block;
        width: 64px;
        height: 24px;
        line-height: 24px;
        background: #60DEB4;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        letter-spacing: 3px;
        text-align: center;
    }

    .report_time {
        line-height: 24px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #888888;
        padding-right: 30px;
        box-sizing: border-box;
    }

    .report_desc {
        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .report_subtitle {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #262633;
        line-height: 32px;
        padding-bottom: 18px;
        display: inline-block;
        
        padding-left: 2px;
        box-sizing: border-box;

    }

    .title_box {
        padding-top: 32px;
        box-sizing: border-box;

        .title_line {
            margin-top: -2px;
            height: 2px;
            background: #F4F4F5;
            position: relative;
            &:before{
                width: 120px;
                height: 4px;
                background: #60DEB4;
                content:'';
                position: absolute;
                left:0;
                top:-1px;
            }
        }
    }

    .testresult {
        padding: 16px 0 16px 16px;
        box-sizing: border-box;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #262633;
        line-height: 32px;
        position: relative;

        &:before {
            content: '';
            position: absolute;
            left: 0%;
            top: 50%;
            transform: translate(0, -50%);
            width: 8px;
            height: 8px;
            background: #60DEB4;
            border-radius: 56px;

        }
    }
    .testresult_vs{
        width: 42px;
        height: 42px;
        background: #D5D5D7;
        display: inline-block;
        border-radius: 50%;
        font-size: 21px;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 42px;
        text-align: center;
        vertical-align: middle;
        margin:104px 30px 0;
    }

    .padding_top_38{
        padding: 38px 0 22px;
        box-sizing: border-box;
    }
    .result1 {
        padding-left: 16px;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .resultNum {
        font-size: 40px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 40px;
        padding-bottom: 10px;
    }

    .resultdesc {
        padding-top: 10px;
        font-size: 12px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #51515C;
        line-height: 14px;
        position: relative;


        &:before {
            content: '';
            position: absolute;
            top: 0;
            width: 40px;
            height: 1px;
            background-color: #F4F4F5;
            left: 0;

        }
    }

    .padding_top_28 {
        // padding-top: 28px;
        padding-left: 46px;
        box-sizing: border-box;
    }

    .padding_top_20 {
        // padding-top: 20px;
        padding-right: 20px;
        box-sizing: border-box;
    }

    .padding_right_184 {
        padding-right: 184px;
        box-sizing: border-box;
    }

    .padding_right64 {
        padding-right: 64px;
        box-sizing: border-box;
    }

    .padding_left_42 {
        padding-left: 12px;
        box-sizing: border-box;
    }

    .fishdesc {
        text-align: center;
        font-size: 16px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #51515C;
        padding-top: 8px;
        box-sizing: border-box;
    }

    .fishimg {
        position: absolute;
        left: 22px;
        top: 50%;
        transform: translate(0, -50%);
    }

    .fishqcround {
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        display: inline-block;
        background-image: url('http://p1.fishqc.net/FjD4dfCGmBJ33_K3UcPUinzSx0De');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        // background-color: #53D5C2;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        border-radius: 50%;
        margin-left: 71px;
        padding-left: 6px;
        box-sizing: border-box;

        &.green {
            // background-color: #53D5C2;
        }

        &.yellow {
            // background-color: #FFDB69;
        }

        &.red {
            // background-color:#FF7338;
        }

        &.grave {
            background-image: url('http://p1.fishqc.net/FvyRjPY9ceyjmo3xS6t9e_0Jve2i');
        }

        &.margin_left0 {
            margin-left: 0;
        }
    }

    .desc2 {
        padding-top: 26px;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .desc3 {
        padding-top: 24px;
        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .rankItem {
        .rankItem_productimg {
            width: 148px;
            height: 100%;
            background-image: url('http://p1.fishqc.net/FiVwYzbfQSdgjBZRGyqwknMlLTyb!product.thumb');
            background-size: contain;
            background-position: center center;
            background-repeat: no-repeat;
        }

        .product_title {
            padding-top: 14px;
            box-sizing: border-box;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #353C46;
            line-height: 24px;
        }

        .product_bable {
            margin: 8px 0 0px;
            padding: 6px 16px 6px 4px;
            box-sizing: border-box;
            background-color: #6EDECD;
            font-size: 9px;
            line-height: 9px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #fff;
            display: inline-block;
            position: relative;

            &:after {
                content: '';
                position: absolute;
                right: -10px;
                top: 0;
                width: 22px;
                height: 21px;
                background-image: url('http://p1.fishqc.net/FujtO5kFbA_ovum4FQIsxSQBvCVN');
                background-size: contain;
                background-position: 0px center;
                background-repeat: no-repeat;
            }
        }

        .productdetail {
            margin: 0px 32px 16px 0;
            box-sizing: border-box;
        }

        .productitemdetail {
            font-size: 12px;

            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #9B9B9B;

            .productitemdetails {
                padding: 6px 0;
                border-bottom: 1px solid #F8F8F8;

                &:last-child {
                    border-bottom: none;
                    padding-bottom: 0;
                }

                .color {
                    color: #333;
                }

                .fix-width-60 {
                    width: 76px;
                    display: inline-block;
                }
            }
        }
    }

    .secondtitle {
        padding: 0 0 10px 16px;
        box-sizing: border-box;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 32px;

        &.padding_top_24 {
            padding-top: 24px;
            box-sizing: border-box;
        }
    }
}

.rankItem {
    width: 384px;
    height: 184px;
    margin-top: 24px;
    border: 1px solid #F4F4F5;
    margin-right: 20px;
    cursor: pointer;
    &:nth-of-type(2n) {
        margin-right: 0;
    }
}

.fishblock {
    width: 100%;
    height: 120px;
    background-color: #EBFFFE;
    box-sizing: border-box;
    margin-bottom: 24px;
    padding: 30px 0 30px 36px;

    &:nth-of-type(1) {
        margin-top: 32px;
    }

    &.green {
        background: #EBFFFE;
    }

    &.yellow {
        background: #FFFDF1;
    }

    &.red {
        background: #FFF5F1;
    }

    .padding_left_16 {
        padding-left: 16px;
        box-sizing: border-box;
    }

    .title {

        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #53D5C2;
        line-height: 22px;
        padding-bottom: 8px;
        box-sizing: border-box;

        &.yellowcolor {
            color: #FFC72F;
        }

        &.redcolor {
            color: #FF8437;
        }
    }

    .desc {

        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #51515C;
        line-height: 16px;
    }


}

.desc4 {
    padding-top: 6px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    text-align: justify;
}

.tiaochacontain {
    padding: 0 10px 0 42px;
    box-sizing: border-box;
}

.tiaochaimg {
    padding-top: 24px;
    box-sizing: border-box;
}

.tiaochatxt {
    // padding-top: 14px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #333;
    line-height: 24px;
}

.padding_left_16 {
    padding-left: 16px;
    box-sizing: border-box;
}

.desc5 {
    padding: 0 0 16px 0px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
}

.reportinfo_text {
    width: 278px;
    height: 61px;
    background: #FFFFFF;
    border-radius: 40px;
    border: 1px solid #DBDCDC;
    position: absolute;
    right: -278px;
    bottom: 8px;
    padding: 6px 20px 0 56px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262633;
    line-height: 24px;

    .position_left {
        position: absolute;
        left: -36px;
        top: -12px;
    }
}

.reportinfo_img1 {
    width: 484px;
    height: 293px;
    background-color: #eee;
}

.reportinfo_img2 {
    width: 369px;
    height: 200px;
    line-height: 200px;
    background-color: #666;
    text-align: center;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}

.reportinfo_img3 {
    width: 238px;
    height: 200px;
    line-height: 200px;
    background-color: #666;
    text-align: center;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}

.vs-right-ul_left {
    padding-left: 24px;
    box-sizing: border-box;
}

.vs-right-li {
    height: 32px;
    line-height: 32px;
    background: #F0FFFC;
    border-radius: 16px;
    background-color: #F0FFFC;
    font-size: 16px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #60DEB4;
    padding: 0 20px 0 30px;
    margin-bottom: 14px;
    display: inline-block;
    position: relative;

    &:before {
        content: '';
        width: 13px;
        height: 13px;
        display: inline-block;
        border-radius: 50%;
        background-color: #60DEB4;
        position: absolute;
        left: 9px;
        top: 10px;
    }

    &.grave{
        color:#A8A8AD;
        background-color: #F4F4F5;
        padding:0  15px ;
        margin-left: 13px;
        &:before {
            content: '';
            width: 13px;
            height: 13px;
            display: inline-block;
            border-radius: 50%;
            background-color: #A8A8AD;
            position: absolute;
            left: -19px;
            top: 10px;
        }
    }
}

.padding_top_24 {
    padding-top: 24px;
    box-sizing: border-box;
}

.desc6 {
    padding: 16px 0;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 28px;
}

.desc7 {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 32px;
    padding-bottom: 22px;
}

.desc8 {
    padding-left: 30px;
    font-size: 16px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    text-align: justify;
}

.desc9 {
    padding-bottom: 16px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    text-align: justify;

    .strong {
        font-weight: bold;
    }
}

.padding_top_32 {
    padding-top: 32px !important;
    box-sizing: border-box;
}

.padding_bottom_30 {
    padding-bottom: 30px;
    box-sizing: border-box;
}

.fishqc_tech_title {
    box-sizing: border-box;
    font-size: 18px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #262633;
    line-height: 26px;
    width:260px;
    padding-left: 40px;
    
    span{
        font-size: 18px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #262633;
        line-height: 30px;
    }
    &.lie2{
        width:240px;
        padding-left: 40px;
        text-align: justify;
    }

    &.lie3{
        width:200px;
        padding-left: 40px;
    }

    &.lie4{
    }

    &.margin_left_42 {
        margin-left: 42px;
    }

    &.margin_left_50 {
        margin-left: 50px;
    }

    .testresult_status{
        font-size: 14px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #51BDC1;
        line-height: 18px;
        &.yellow{
            color:#FFC72F;
        }

        &.red{
            color:#FF8437;
        }
    }

    .fishqc_table{
        padding-top:32px;
        box-sizing:border-box;
        display: inline-block;

        &.padding_top_15{
            padding-top: 15px;
            box-sizing: border-box;
        }
    }


}

.height_80 {
    width: 100%;
    height: 80px;
    padding-top: 14px;
    box-sizing: border-box;
    background-color: #F8FBFD;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 30px;
}

.height_150 {
    width: 100%;
    height: 150px;
    background-color: #F1FFFA;
    // padding-top: 32px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 30px;
}

.height_150_yellow {
    width: 100%;
    height: 150px;
    background-color: #FFFDF1;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 30px;
}

.height_150_red {
    width: 100%;
    height: 150px;
    background-color: #FFF5F1;
    box-sizing: border-box;
}

.collect_btn{
    width: 144px;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #60DEB4;
    margin:52px auto 62px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #60DEB4;
    line-height: 48px;
    letter-spacing: 4px;
    padding-left:66px;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;
   &:before{
        content:'';
        position: absolute;
        left: 38px;
        top:15px;
        width:19px;
        height: 18px;
        background: url('http://p1.fishqc.net/FpwPBMetiVz9yF37lsc3VBjuC421') center center no-repeat;
   }
}

.publish{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    line-height: 12px;
}
</style>
<style type="text/css" lang="scss">
</style>
<script>
import { myMixin } from '@/mixin/mixin.js'

export default {
    name: 'fishqcinfo',
    props: {
        list: Array

    },
    components: {

    },
    mixins: [myMixin],
    data() {
        return {
            rank_fish_desc: {
                'green': {
                    class: 'green',
                    textcolor: '',
                    fish: 'http://p1.fishqc.net/FntGTR6jrfjgtGacnLpJLDmyTS9E',
                    title: this.$t('common.green_Title'),
                    desc: this.$t('common.green_evaluation')
                },
                'yellow': {
                    class: 'yellow',
                    textcolor: 'yellowcolor',
                    fish: 'http://p1.fishqc.net/FiCoMYuJByMzrWJuEDYJRuriTI__',
                    title: this.$t('common.yellow_Title'),
                    desc: this.$t('common.yellow_evaluation')
                },
                'red': {
                    class: 'red',
                    textcolor: 'redcolor',
                    fish: 'http://p1.fishqc.net/Fnes1J7ChIMQbPR7AHgQMg5wSSJ2',
                    title: this.$t('common.red_Title'),
                    desc: this.$t('common.red_evaluation')
                }
            },
            

        }
    },
    methods: {
    },
    computed: {
      
    },
    mounted() {
        //console.log(this.$parent.$refs)
        this.$parent.$refs['fishqc_stander'] = this.$refs['fishqc_stander']
        this.$parent.$refs['fishqc_introduction'] = this.$refs['fishqc_introduction']
    }
}
</script>